<template>
	<div>
		<a-modal v-show='ishand' id='areasimple' width='47.5rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">盈利（虧損）走勢圖
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="height: 24rem;padding-top: 2.8rem;">
				<div style="padding-left: 2rem;">
					<button class='btn1' :class='btnstatic == "week"?"btnx":""' @click='handopen("week")'>最近一周</button>
					<button class='btn1' :class='btnstatic == "month"?"btnx":""'
						@click='handopen("month")'>最近一月</button>
					<button class='btn1' :class='btnstatic == "year"?"btnx":""' @click='handopen("year")'>最近一年</button>
					<img :src="require('@/image/find.png')" alt=""
						style="margin-left: 7.5rem;width: 1.1rem;margin-right: .5rem;">
					<a-range-picker @change="onChange" :placeholder='["開始日期","結束日期"]' v-model='begindate'
						style='width: 15rem;'>
						<!-- <a-icon slot="suffixIcon" type="smile" /> -->
						<img slot="suffixIcon" :src="require('@/image/datelist.png')" alt="">
					</a-range-picker>
				</div>
				<areaChart :ref="navCense.id" :dataBol="dataBol"  :widthPxMess="widthPxMess"
					:useData="navCense"></areaChart>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import areaChart from '@/components/chart/areaChart'
	import App from '@/assets/app.js';
	export default {
		props: ['openstatic', 'states'],
		components: {
			areaChart,
		},
		data() {
			return {
				btnstatic: "week",
				begindate: [],
				visible: true,
				ishand: true,
				navCense: {
					id: 'areaChart1'
				},
				// 子組件傳值 判定是否數據接收
				dataBol: false,
				widthPxMess: {},
			}
		},
		watch:{
			dataBol:{
				handler(ev){
					console.log(ev)
				}
			}
		},
		mounted() {
			let widthPxMess = {
				XYSize: 14, //0.73
				legendSize: 14, //0.73
				legendWidth: 130, //6.8
				titleSize: 20, //1
			};
			// let data3 = data.navCense;
			let navCense = {
				x: [],
				data: [],
				title: '',
				id: 'areaChart1'
			};
			// for (let a in data3) {
			// 	navCense.x.push(a);
			// 	navCense.data.push(data3[a])
			// };
			navCense.series = [{
					name: '',
					type: 'line',
					smooth: true,
					areaStyle: {
						opacity: 0.8,
						color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							offset: 0,
							color: '#fb2b29'
						}, {
							offset: 1,
							color: '#fac93c'
						}]),
					},
					data: navCense.data
				}],
				navCense.ckname = '';
			this.navCense = navCense;
			// this.dataBol = true;
			this.handit()
		},
		watch: {

		},
		methods: {
			handopen(val) {
				this.$forceUpdate()
				this.btnstatic = val
				this.begindate = []
				this.handit()
			},
			onChange() {
				this.$forceUpdate()
				this.btnstatic = ''
				if (this.begindate[0] && this.begindate[1]) {
					this.handit({
						"token": this.$store.state.token,
						"stockcode": this.states.stockcode,
						begindate: this.formatDatefn(this.begindate[0]),
						enddate: this.formatDatefn(this.begindate[1]),
					})
				}
			},
			formatDatefn(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? '0' + m : m;
				var d = date.getDate();
				d = d < 10 ? '0' + d : d;
				return y + '-' + m + '-' + d;
			},
			handit(objdate = {
				"token": this.$store.state.token,
				"stockcode": this.states.stockcode,
				flag: this.btnstatic
			}) {
				this.dataBol = false
				let obj = objdate
				this.$ajax({
					url: this.$api.getPlChartData,
					method: 'post',
					data: obj
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						let plr = [],
							avgpricearr = [],
							price = [],
							qty = [];

						res.data.data.map(ev => {
							plr.push(ev.pl)
							price.push(ev.referenceval)
							qty.push(ev.qty)
							avgpricearr.push(ev.avgprice)
						})
						this.navCense.avgpricearr = avgpricearr
						this.navCense.plr = plr
						this.navCense.qty = qty
						this.navCense.price = price
						this.navCense.datearrs = res.data
						if (res.data.data.length == 1) {
							this.navCense.plr.unshift(0)
							this.navCense.avgpricearr.unshift(0)
							this.navCense.price.unshift(0)
							this.navCense.qty.unshift(0)
							this.navCense.datearrs['data-x'].unshift(0)
						}
						this.navCense.ccy = this.states.ccy
						this.dataBol = true
						console.log(this.dataBol)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			portfoliofn() {
				this.$ajax({
					method: 'post',
					url: this.$api.portfolio,
					data: {
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode == 1000) {

					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
		}
	}
</script>

<style lang="scss" scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}
</style>
<style lang="scss">
	#areasimple {
		.ant-modal {
			top: 22vh;
		}

		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem;
			}
		}

		.ant-modal-content {
			border-radius: 10px !important;
		}

		.ant-table-column-title {
			font-weight: 600;
		}

		.ant-table-row-cell-break-word {
			color: #000;
		}

		.btn1 {
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			margin: 0 .5rem;
			background-color: #0c8b97;
		}

		.btnx {
			background-color: #e99c00;
		}
	}
</style>
